import { createSelector } from 'reselect'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { isOnlyInterestedInNutritionProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'

export const getAppPathSelect = createSelector(
  isOnlyInterestedInNutritionProfileSelect,
  (isInterestedInNutrition) => {
    return isInterestedInNutrition
      ? ROUTE_PATH.TRACK_CALORIES
      : ROUTE_PATH.APP
  }
)
